/**
 * Created by rickborst on 16/06/2017.
 */

import {
    convertForRead,
    convertFromRead
} from '../adapters/config';
import {
    isValidResponse
} from '../validators/config';

/**
 * Gets and returns the application configuration.
 *
 * @param {Object} params - Request params.
 * @returns {Promise} Get configuration promise.
 */
export async function getConfig (params = {}) {
    let data;

    if (this._configLoaded) {
        return Promise.resolve(this);
    }

    if (this._loadingConfigPromise) {
       return this._loadingConfigPromise;
    }

    data = await convertForRead.call(this, params);

    this._loadingConfigPromise = this
        .read({
            url: data.url,
            isConfigRequest: true,
            method: 'GET'
        })
        .catch(() => {

            return Promise.reject({
                result: {
                    error: 'Application configuration could not be loaded.'
                }
            });
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {

            return convertFromRead.call(this, response);
        });

    return this._loadingConfigPromise;
}

/**
 * Updates device with generated one.
 *
 * @param {Object} device - New device.
 */
export function updateDeviceID (device) {
    this._updateDeviceID(device.udid);
}





// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/config.js